import React from 'react';
import styled from "styled-components";

import "./components/helpers/font.css"
import ResumeBuilder from "./components/ResumeBuilder/ResumeBuilder";
import './App.css';
import media from "./helpers/media";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-67098710-2');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <BgColor className="App">
      <ResumeWrapper>
        <ResumeBuilder />
      </ResumeWrapper>
    </BgColor>
  );
}

const getBackgroundColor = () => {
  let colors = [
    "linear-gradient(to right, #ede574, #e1f5c4)",
    "linear-gradient(to right, #dad299,#b0dab9)",
    "linear-gradient(to right, #c9ffbf, #ffafbd)",
    "linear-gradient(to right, #fdc830, #f37335)",
    "linear-gradient(to right, #d1913c, #ffd194)",
    "linear-gradient(to right, #ff9966, #ff5e62)",
    "linear-gradient(to right, #dad299,#b0dab9)",
    "linear-gradient(to right, #ee9ca7, #ffdde1)",
    "linear-gradient(to right, #38ef7d, #11998e)",
    "linear-gradient(to right, #fd746c, #ff9068)",
    "linear-gradient(to right, #ccccb2, #757519)"
  ];
  return colors[Math.floor(Math.random() * 11)];
};


export const BgColor = styled.div`
  background: ${getBackgroundColor()};
`;

const ResumeWrapper = styled.div`
  width: 100vw ;
  height:100vh;
  z-index: 99;
  margin-top: 70px;
  @media ${media.tablet}{
    margin-bottom: 100px;
    width:210mm;
    min-height: 297mm !important;
    margin-top: 90px;
  }
`;


export default App;
